import {ViewEncapsulation, Component} from '@angular/core';
import {SessionService} from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-blocked-session',
  templateUrl: './blocked-session.component.html',
  styleUrl: './blocked-session.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BlockedSessionComponent {

  constructor(private sessionService: SessionService) {}

  reactivateSession() {
    this.sessionService.reactivateTab();
  }

}